var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedshift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205B97",
    d: "m125.5 176.625 75.18 17.836V54.141L125.5 71.979v104.647Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5193CE",
    d: "M200.68 54.142 215 61.276v126.051l-14.32 7.134V54.141ZM125.5 176.625l-75.18 17.836V54.141l75.18 17.837v104.647Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#205B97",
    d: "M50.32 54.142 36 61.276v126.051l14.32 7.134V54.141Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5193CE",
    d: "m144.597 223 28.64-14.269V40.269L144.597 26l-8.756 93.547L144.597 223Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#205B97",
    d: "m106.403 223-28.64-14.269V40.269L106.403 26l8.756 93.547L106.403 223Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E73B7",
    d: "M106.403 26h38.582v196.602h-38.582V26Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 26h179v197H36z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedshift);
export default __webpack_public_path__ + "static/media/Redshift.cedae95d93d503c1f9f8f4bbc41b4c98.svg";
export { ForwardRef as ReactComponent };